enum ArticleAiNarrationStatus {
    PENDING = 0,
    SUCCESS = 1,
    FAILURE = 2,
}

export default ArticleAiNarrationStatus;
